/**
 * @fileoverview Chain / TON deploy URLs
 * @description Centralizes deploy-time URLs that were previously hardcoded
 *   so each environment (staging / production / k8s) can override them via
 *   VITE_* env vars instead of editing source. Mirrors the lib/tgConfig.ts
 *   pattern (import.meta.env with a sane default).
 * @module lib/chainUrls
 */

/** TON Connect dapp manifest URL (must be HTTPS, publicly reachable). */
export const TON_MANIFEST_URL: string =
  import.meta.env.VITE_TON_MANIFEST_URL ||
  'https://s3.ap-southeast-1.amazonaws.com/cdn.augurx.win/mainifest.json';

/** tonapi.io base used to resolve a user's Jetton wallet address (no trailing slash). */
export const TON_API_BASE: string = String(
  import.meta.env.VITE_TON_API_BASE || 'https://tonapi.io'
).replace(/\/+$/, '');

/** Build a tonapi jetton-wallet lookup URL for an owner + jetton master. */
export function tonJettonWalletApiUrl(userTonAddress: string, tokenAddress: string): string {
  return `${TON_API_BASE}/v2/accounts/${encodeURIComponent(userTonAddress)}/jettons/${encodeURIComponent(tokenAddress)}`;
}

/** TON transaction explorer base (append the tx hash). */
export const TON_EXPLORER_TX: string =
  import.meta.env.VITE_TON_EXPLORER_TX || 'https://tonscan.org/tx/';

/** EVM transaction explorer base (append the tx hash). */
export const EVM_EXPLORER_TX: string =
  import.meta.env.VITE_EVM_EXPLORER_TX || 'https://bscscan.com/tx/';

/** App logo URL for WalletConnect dapp metadata (HTTPS). */
export const APP_LOGO_URL: string =
  import.meta.env.VITE_APP_LOGO_URL || 'https://www.augurx.win/logo.png';
